/**
 * Add to Cart - AJAX Handler (No Redirect)
 * Prevents redirect to cart page on add to cart
 */
(function () {
  "use strict";

  function initAddToCartAjax() {
    var addToCartBtn = document.querySelector(
      '#AddToCart[data-ajax-cart="true"]'
    );
    var form = document.getElementById("AddToCartForm");

    if (!addToCartBtn || !form) {
      return;
    }

    addToCartBtn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();

      var formData = new FormData(form);

      // Add loading state
      addToCartBtn.classList.add("loading");
      addToCartBtn.disabled = true;

      // AJAX add to cart (no redirect)
      fetch("/cart/add.js", {
        method: "POST",
        body: formData,
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error("Failed to add to cart");
          }
          return response.json();
        })
        .then(function (data) {
          // Remove loading state
          addToCartBtn.classList.remove("loading");
          addToCartBtn.disabled = false;

          // Show success feedback (optional - can customize)
          var originalIcon = addToCartBtn.innerHTML;
          addToCartBtn.innerHTML = '<i class="ion-checkmark-round"></i>';

          // Trigger cart drawer/notification if exists
          if (typeof Shopify !== "undefined" && Shopify.onItemAdded) {
            Shopify.onItemAdded(data);
          }

          // Update cart count
          if (typeof ajaxCart !== "undefined" && ajaxCart.load) {
            ajaxCart.load();
          }

          // Trigger custom event for cart update
          document.dispatchEvent(
            new CustomEvent("cart:updated", { detail: data })
          );

          // Restore icon after 2 seconds
          setTimeout(function () {
            addToCartBtn.innerHTML = originalIcon;
          }, 2000);
        })
        .catch(function (error) {
          console.error("Add to cart error:", error);
          addToCartBtn.classList.remove("loading");
          addToCartBtn.disabled = false;
          alert("Unable to add to cart. Please try again.");
        });
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAddToCartAjax);
  } else {
    // DOM already loaded
    initAddToCartAjax();
  }
})();
